import { render } from "./product-accordion.vue?vue&type=template&id=03636fde"
import script from "./product-accordion.vue?vue&type=script&lang=js"
export * from "./product-accordion.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak-fr1/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__